import { useCallback, useState } from "react";
import moment from "moment";

export interface FiltroConciliacao {
  contasBancariasIds?: string[];
  date: moment.Moment;
}

export const defaultFiltroConciliacao: FiltroConciliacao = {
  date: moment(),
};

function useFiltroConciliacao() {
  const [filtro, setFiltro] = useState<FiltroConciliacao>(
    defaultFiltroConciliacao
  );

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroConciliacao>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroConciliacao);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroConciliacao;
